<script>
import { Bar  } from "vue-chartjs";
// const { reactiveProp } = mixins;


export default {
  extends: Bar,
  props: ["data", "height", "options"],
  //  mixins: [reactiveProp],
  mounted() {
    this.renderLineChart();
  
  },
  methods: {
    renderLineChart: function() {
      this.renderChart(this.data, this.options);
    }
  },
  watch: {
    data: function() {
      this.$data._chart.destroy();
      this.renderLineChart();
      //this.$data._chart.update(0);
    }
  }
};
</script>